import { SessionActivity } from "./activity"
import { ActivityType } from "../../lesson/activity/activity.types"
import { LessonActivity } from "./lesson-activity.types"


export class ActivityUtil {

  static activityName(activity: LessonActivity): string | null {

    let name = ""
    name += activity.level_name ? `${activity.level_name} - ` : ""
    name += activity.topic_name ? `${activity.topic_name} - ` : ""
    name += activity.activity_node?.[0]?.name || ""
    name += activity.activity_node?.[0]?.node_name || ""
    name += activity.activity_node?.[0]?.video_name || ""

    return name

  }

}

